import React from "react";
import Extension from "@contentstack/app-sdk/dist/src/extension";
import { KeyValueString } from "../types/types";

export type MarketplaceAppContextType = {
  appSdk: Extension | null;
  appConfig: KeyValueString | null;
};

export const MarketplaceAppContext = React.createContext<MarketplaceAppContextType>({
  appSdk: null,
  appConfig: null,
});
